<template>
<div class="p-4 back_princ">

<div class=" d-flex justify-content-center text-info">
 <i class="fas fa-boxes fa-4x"></i>
</div>

<div class=" d-flex justify-content-center text-info mb-4">
 <h2 class="font-weight-lighter">Rapports Ressources Humainnes</h2>
</div>




<div class=" row p-4">

            <!-- Earnings (Monthly) Card Example -->
            <div v-if="d_gst_absencerh==true" class="col">
              <div class="btn card border border-light shadow h-100 py-2" @click="click_absenc">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-secondary text-uppercase">Absences</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-clipboard-list fa-2x text-secondary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Earnings (Annual) Card Example  -->
            <div v-if="d_gst_congesrh==true" class="col">
              <div class="btn card border border-light shadow h-100 py-2"  @click="click_conges">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-secondary  text-uppercase">Congés</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-user-check  fa-2x text-secondary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
</div>

<div  class=" row p-4">

              <!-- Earnings (Annual) Card Example  -->
            <div class="col">
              <div class="btn card border border-light shadow h-100 py-2"  @click="click_heures">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-secondary  text-uppercase">Heures Travaillées</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-user-clock fa-2x text-secondary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

</div>


<div v-if="d_gst_trait_salaire==true" class=" row p-4">



                        <!-- Earnings (Monthly) Card Example  --> 
            <div class="col">
              <div class="btn card border border-light shadow h-100 py-2" @click="click_salaire">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="font-weight-bold text-success  text-uppercase "> Liste Des Salaires Des Employés</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-user-check fa-2x text-success"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>


</div>





  </div>
</template>

<script>
export default {

    computed: {
            d_gst_trait_salaire() {
      return this.$store.getters.get_gst_trait_salaire;
    },
    d_gst_absencerh() {
      return this.$store.getters.get_gst_absencerh;
    },
    d_gst_congesrh() {
      return this.$store.getters.get_gst_congesrh;
    }
    },
 methods:{

      click_heures()
      {
                      //goto first page:
                    this.$router.push({ 
                        name: 'pointageRapp'

                    });
      },
      click_conges()
      {
                      //goto first page:
                    this.$router.push({ 
                        name: 'congesRapp'

                    });
      },
       click_absenc()
      {
                      //goto first page:
                    this.$router.push({ 
                        name: 'absencesRapp'

                    });
      },
      click_salaire() 
      {
                       //goto first page:
                    this.$router.push({ 
                        name: 'salairesListRapp'

                    });
      },


 }
}
</script>
<style scoped>
.back_princ{
  background: #eff7fa;
}

.text_org{
  color: green;
}
</style>